import React, { useRef } from 'react';
import { protectPDF } from '../../SmartContract/protectPDF';
import { updateNFT } from '../../SmartContract/updateNFT';
import { FileInput, StyledButtonUpload } from './styles';
import { recarregarTela } from '../FileUploadBlockchain';
import Swal from 'sweetalert2';
import { blockchainService } from '../../../../services/blockchainService';
import { projectService } from '../../../../services/projectService';

export const useFileUpload = () => {
  const selectFile = (event, fieldName, modelo_item_id, uuidv4, setFileStates, project_id, tela_name, fileStates) => {
    if (!event?.target?.files?.[0]) {
      console.error('Invalid file selection event');
      return;
    }

    const selectedFile = event.target.files[0];
    const guid = uuidv4();
    const ext = selectedFile.name.split('.').pop();

    const reader = new FileReader();

    reader.onload = async (e) => {
      const arquivo_fisico_content = e.target.result;
      const arquivo_fisico_base64 = arquivo_fisico_content.split(',')[1];

      const retorno = await protectPDF(guid, null);

      setFileStates((prevState) => ({
        ...prevState,
        [fieldName]: {
          id: guid,
          name_guid_ext: guid,
          path: `${tela_name}/${guid}.${ext}`,
          ativo: true,
          project_id: project_id,
          name_orig_ext: selectedFile.name,
          modelo_item_id: modelo_item_id,
          name_ext_ext: ext,
          arquivo_fisico: arquivo_fisico_base64,
          signature: retorno.signature
        },
      }));
    };

    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };

    reader.readAsDataURL(selectedFile);
    return fileStates[fieldName];
  };

  return { selectFile };
};

export const FileUploadComponentPDF = ({ item, handleFileChange, disabled = false }) => {
  const fileInputRef = useRef(null);

  const validateFile = (file) => {
    if (file.type !== 'application/pdf') {
      alert('Por favor, envie apenas arquivos PDF.');
      return false;
    }

    const maxSizeInBytes = 100 * 1024 * 1024; 
    if (file.size > maxSizeInBytes) {
      alert(`O tamanho do arquivo ${file.name}: ${file.size / 1000000} deve ser menor que 100 MB.`);
      return false;
    }
    return true;
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file && validateFile(file)) {
      // TopicDocuments passa um wrapper (e) => ...; FileUploadBlockchain usa (e, fieldName)
      handleFileChange(event, item.fileNameFile || item.fileName || item.modelo_item_id);
    } else {
      event.target.value = '';
    }
  };

  const handleButtonClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div
      style={{
        opacity: disabled ? 0.5 : 1,
        //pointerEvents: disabled ? 'none' : 'auto',
        transition: 'opacity 0.3s ease',
        display: 'inline-block',
      }}
    >
      <StyledButtonUpload
        onClick={handleButtonClick}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          backgroundColor: disabled ? 'var(--border-default)' : undefined,
        }}
        disabled={disabled}
      >
        Up PDF
      </StyledButtonUpload>
      <FileInput
        id={String(item.fileNameFile || item.fileName || item.modelo_item_id || 'pdf-upload')}
        name={String(item.fileNameFile || item.fileName || item.modelo_item_id || 'pdf-upload')}
        onChange={handleChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export const useSelectFile = ({
  uuidv4,
  setFileStates,
  project_id,
  tela_name,
  fileStates
}) => {
  const handleSelectFile = async (event, fieldName, modelo_item_id) => {
    if (!event?.target?.files?.[0]) return;

    const selectedFile = event.target.files[0];
    const guid = uuidv4();
    const ext = (selectedFile.name.split('.').pop() || 'pdf').toLowerCase();
    const reader = new FileReader();

    reader.onload = async (e) => {
      const arquivo_fisico_content = e.target.result;
      const arquivo_fisico_base64 = arquivo_fisico_content.split(',')[1];
      const folder = (tela_name || 'documentos').trim();

      // Path alinhado ao canônico do backend: `{nome_do_modelo}/{guid}.pdf`
      setFileStates((prevState) => ({
        ...prevState,
        [fieldName]: {
          id: guid,
          name_guid_ext: guid,
          path: `${folder}/${guid}.${ext}`,
          ativo: true,
          project_id: project_id,
          name_orig_ext: selectedFile.name,
          modelo_item_id: modelo_item_id,
          name_ext_ext: ext,
          arquivo_fisico: arquivo_fisico_base64,
        },
      }));
    };
    reader.readAsDataURL(selectedFile);
    return fileStates[fieldName];
  };

  return { handleSelectFile };
};

export function substituirDocumento(
  __document_guid,
  __item,
  __item_fileNameFile,
  __item_modelo_item_id,
  project_id,
  contract_file_manager_contract,
  axios,
  headers,
  contract_contract_address_client,
  contract_wallet_owner,
  uuidv4,
  tela_name,
  createRoot,
  FileUploadComponentPDF,
  verifyUser) {
  var fileStatesLocal = '';
  var resposta_nft_ok = false;

  //UPDATE NA BLOCKCHAIN
  const updateNft = async (
    document_guid,
    document_name,
    file_manager_topic_id,
    item_document_path,
    token_id,
    modelo_item_id
  ) => {
    try {
      const dominio_site = 'http://teste.com.br/';
      const _nftTitle = document_guid;
      const _nftDescription = document_name;
      const _nftPrice = 1;
      const _nftRoyaltyPercentage = 1;
      const _nftImageUrl = dominio_site + item_document_path;

      const requestData = {
        Document_id: document_guid,
        project_id: project_id,
        Contract_id: contract_file_manager_contract,
        Topic_id: file_manager_topic_id,
        title: _nftTitle,
        description: _nftDescription,
        price: _nftPrice,
        royalty: _nftRoyaltyPercentage,
        img_url: _nftImageUrl,
        modelo_item_id: modelo_item_id,
      };

      // 🔁 Chamada centralizada ao blockchainService
      const response1 = await blockchainService.insertFileManagerNft(requestData, headers);
      const file_manager_nft_id = response1.id;

      try {
        const retorno = await updateNFT(
          contract_contract_address_client,
          contract_wallet_owner,
          token_id,
          _nftTitle,
          _nftDescription,
          _nftPrice,
          _nftRoyaltyPercentage,
          _nftImageUrl,
          file_manager_nft_id
        );

        console.log('✅ NFT atualizada na blockchain:', retorno);

        const respostaAtualizacao = await blockchainService.atualizarJsonResponseNft(
          retorno.file_manager_nft_id,
          retorno,
          retorno.contratoAddress,
          retorno.contratoClienteAddress,
          retorno.signerGeral,
          retorno.tokenId,
          retorno.signer,
          retorno.signature,
          retorno.hashedMessage
        );

        console.log('🧩 JSON atualizado:', respostaAtualizacao);

        const data2 = await blockchainService.atualizarData3Nft(retorno);
        console.log('💾 NFT - Atualizada com Sucesso!');
        resposta_nft_ok = true;

      } catch (error) {
        await blockchainService.atualizaCampoErroNftSubstituir(
          file_manager_nft_id,
          error.signer,
          error.signature,
          error.hashedMessage,
          error
        );
        console.error('❌ NFT - Erro ao tentar atualizar NFT na blockchain!');
        resposta_nft_ok = false;
      }

      recarregarTela();

    } catch (error) {
      console.error('❌ Erro geral ao atualizar NFT:', error);
    }
  };

  const handleFileChangeLocal = (event, fieldName, modelo_item_id) => {
    const selectedFile = event.target.files[0];
    const guid = uuidv4();
    const ext = selectedFile.name.split('.').pop();

    const reader = new FileReader();

    reader.onload = (e) => {
      const arquivo_fisico_content = e.target.result;
      const arquivo_fisico_base64 = btoa(arquivo_fisico_content);

      const objeto = {
        [fieldName]: {
          id: guid,
          name_guid_ext: guid,
          path: `${tela_name}/${guid}.${ext}`,
          ativo: true,
          project_id: project_id,
          name_orig_ext: selectedFile.name,
          modelo_item_id: modelo_item_id,
          name_ext_ext: ext,
          arquivo_fisico: arquivo_fisico_base64,
        }
      };
      fileStatesLocal = objeto;
    };
    reader.readAsArrayBuffer(selectedFile);
  };

  Swal.fire({
    title: 'Confirmação',
    html: `
        <div id="fileUploadComponentContainer"></div>
        <div>
          <label for="justificativa">Justificativa:</label>
          <textarea style="width: 400px; height: 100px;" name="ctl00$ContentPlaceHolder1$txtJustificativa" 
            id="ctl00_ContentPlaceHolder1_txtJustificativa" class="swal2-input" required></textarea>
        </div>
        <div>
        <label for="senha">Senha:</label>
          <input name="ctl00$ContentPlaceHolder1$txtSenhaLogin" type="password" id="ctl00_ContentPlaceHolder1_txtSenha" 
            autocomplete="off" onfocus="this.removeAttribute('readonly');" style="width:200px;" class="swal2-input password-input">        
        </div>        
      `,
    showCancelButton: true,
    confirmButtonText: 'Confirmar Substituição de Documento e NFT',
    cancelButtonText: 'Cancelar',
    focusConfirm: false,
    didOpen: () => {
      const root = createRoot(document.getElementById('fileUploadComponentContainer'));
      root.render(
        <div>
          <div>
            <FileUploadComponentPDF item={__item} handleFileChange={(e) => handleFileChangeLocal(e, __item_fileNameFile, __item_modelo_item_id)} />
          </div>
        </div>
      );
    },
    preConfirm: () => {
      const senha = Swal.getPopup().querySelector('#ctl00_ContentPlaceHolder1_txtSenha').value;
      const justificativa = Swal.getPopup().querySelector('#ctl00_ContentPlaceHolder1_txtJustificativa').value;

      return { senha, justificativa };
    },
  })
    .then(async (result) => {
      if (result && result.isConfirmed) {

        try {

          const retornoVerifyUser = await verifyUser(contract_wallet_owner, __item.file_manager_nft_dt.nft_file_manager_nft_id);
          try {
            if (retornoVerifyUser.is_assinatura_ok) {
              const new_doc = await handleUploadTemp(fileStatesLocal, result.value.justificativa);

              alert(__item_modelo_item_id);

              await updateNft(new_doc.data[0].id, new_doc.data[0].name_orig_ext, new_doc.data[0].modelo_topic, new_doc.data[0].path, __item.file_manager_nft_dt.nft_token_id, __item_modelo_item_id)

              if (resposta_nft_ok) {
                Swal.fire({
                  title: 'Sucesso!',
                  text: 'NFT - Atualizada com sucesso!',
                  icon: 'success',
                  confirmButtonText: 'OK',
                });
              }
              else {
                Swal.fire({
                  title: 'Erro!',
                  text: 'Algo deu errado ao tentar atualizar a NFT, verifique a carteira MetaMask. Por favor, contate nosso suporte! suporte@vertecotech.com',
                  icon: 'error',
                  confirmButtonText: 'OK'
                });
              }
            }
            else {
              const retorno = await blockchainService.atualizaCampoErroNftSubstituir(__item.file_manager_nft_dt.nft_file_manager_nft_id, retornoVerifyUser.signer, retornoVerifyUser.signature, retornoVerifyUser.hashedMessage, retornoVerifyUser);
              console.error('Erro ao atualizar a nft:', retornoVerifyUser);

              Swal.fire({
                title: 'Erro!',
                text: 'Algo deu errado ao tentar atualizar a NFT, verifique a carteira MetaMask. Por favor, contate nosso suporte! suporte@vertecotech.com',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          } catch (error) {
            console.error('Error uploading files:', error);
          }
        } catch (error) {
          const retorno = await blockchainService.atualizaCampoErroNftSubstituir(__item.file_manager_nft_dt.nft_file_manager_nft_id, error.signer, error.signature, error.hashedMessage, error);
          console.error('Erro ao atualizar a nft:', error);

          Swal.fire({
            title: 'Erro!',
            text: 'Algo deu errado ao tentar atualizar a NFT, verifique a carteira MetaMask. Por favor, contate nosso suporte! suporte@vertecotech.com',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          return false;
        }
      }
    })
    .catch((error) => {
      console.error('Error displaying SweetAlert:', error);
    });
}

export const handleUploadTemp = async (
  docs,
  _motivo,
  token,
  headers,
  setBotaoSalvar,
  modelo_GUID,
  project_id,
  setData2,
  setFileStates
) => {
  return new Promise(async (resolve, reject) => {
    try {
      // 🟡 Envia os arquivos via projectService
      const response1 = await projectService.sendFilesUpload(
        docs,
        token
      );

      setBotaoSalvar(true);

      // 🟢 Recarrega os dados do documento via blockchainService
      const response2 = await blockchainService.getDocumentModelData(
        modelo_GUID,
        project_id,
        headers
      );

      // Atualiza o estado da tela
      setData2({ ...response2 });
      setFileStates({});
      setBotaoSalvar(false);

      console.log("✅ Upload e recarregamento concluídos com sucesso!");
      resolve(response1);

    } catch (error) {
      console.error("❌ Falha ao processar upload temporário:", error);

      setBotaoSalvar(false);
      reject(error);

      const errorMessage =
        error?.response?.data?.error ||
        "Ocorreu um erro inesperado ao enviar os arquivos.";

      Swal.fire({
        title: "Erro!",
        text: `${errorMessage} Por favor, contate nosso suporte! suporte@vertecotech.com`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  });
};